<template>
  <div class="filter-campaigns">
    <p v-if="loaded && campaigns.length > 0">Campanha:</p>
    <div>
      <b v-if="!loaded">Carregando...</b>
			<multiselect
				v-if="loaded && campaigns.length > 0"
				class="filter-campaigns__select"
				placeholder="Digite aqui para filtrar"
				noOptions="Sem resultados"

				label="campaign_name"
				track-by="campaign_id"
				
				v-model="selected"
				:options="campaigns"
				:searchable="true"
				:allow-empty="true"
				:show-labels="false"
				:hide-selected="selectMultiple"

				:multiple="selectMultiple"
				:close-on-select="!selectMultiple"

				@remove="setSelected"
				@input="setSelected"
			></multiselect>

			<b-button
				v-if="selected !== null"
				variant="outline-dark"
				size="sm"
				@click="clearFilter">
				limpar
			</b-button>
			
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMidiaCampaigns } from "../../api/midia";
export default {
  data() {
    return {
			selected: null,
			loaded: false,
    };
  },
	props: [ 'selectMultiple' ],
  mounted() {
    this.getMidiaCampaigns();
  },
  computed: {
    ...mapState({
      campaigns: state => state.midia.campaigns
    })
  },
  methods: {
    getMidiaCampaigns,
		setSelected() {
			if (this.selectMultiple === true) {
				if (this.selected.length > 0) {
					var ids = this.selected.map(function(item) {
						return item.campaign_id;
					});
					this.$emit("onChange", ids.join(','));
				} else {
					this.$emit("onChange", null);
				}
			} else {
				this.$emit("onChange", this.selected.campaign_id);
			}
		},
		clearFilter() {
			this.selected = null;
			this.$emit("onChange", null);
		}
  },
  watch: {
    campaigns(data) {
			console.log('campaigns', data)
			this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-campaigns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
	&__select {
		min-width: 200px;
		margin: 0 5px;
	}
  > div {
		align-items: center;
		display: flex;
    font-size: 14px;
		height: 40px;
    .btn {
      height: 30px;
    }
  }
}
</style>
